import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

type ProjectLink = { label: string; href: string };

type Project = {
  title: string;
  description: string;
  links?: ProjectLink[];
};

const projects: Project[] = [
  {
    title: 'CanSat Competition',
    description:
      'Created a ground station application for telemetry, ground workflows, and mission tooling with a collegiate payload team.',
    links: [{ label: 'Source', href: 'https://cansatcompetition.com/' }],
  },
];

function Projects() {
  return (
    <div className="h-screen flex flex-col overflow-hidden">
      <Navbar />
      <main className="flex-grow text-white flex pt-20 min-h-0 overflow-y-auto">
        <div className="flex-1 w-full pb-8">
          <h1 className="text-xl mb-8">Projects</h1>
          <p className="mb-8 text-sm">
            A few of the things I have built. More stuff on my {' '}
            <a href="https://github.com/AwesomeFalcon">GitHub</a>.
          </p>

          <div className="space-y-8">
            {projects.map((project) => (
              <section key={project.title}>
                <h2 className="text-base font-semibold mb-2">{project.title}</h2>
                <p className="text-sm mb-2 leading-relaxed">{project.description}</p>
                {project.links && project.links.length > 0 && (
                  <p className="text-sm">
                    {project.links.map((link, i) => (
                      <React.Fragment key={`${project.title}-${link.label}`}>
                        {i > 0 ? ' · ' : null}
                        <a href={link.href}>{link.label}</a>
                      </React.Fragment>
                    ))}
                  </p>
                )}
              </section>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default Projects;
